import React from 'react';

export function TextClickable({text, click}) {
  return <span className='btn-link text-clickable' onClick={click}>{text}</span>
}
/*
export function useTextClickable(callback) {
  return (text, target) => {
    return <TextClickable text={text} click={() => callback(target)} />
  };
};
*/